var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"container container-principal"},[(_vm.user)?_c('div',{staticClass:"row"},[_c('sub-menu-link',{attrs:{"menu-link":_vm.$root.SubMenuLink,"menu-btn":_vm.$root.SubMenuBtn}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('child')],1)])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5f57eb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/layouts/default.vue
// module id = 6b3m
// module chunks = 49